define('presentation/settings/integrations/facades/integrationsFacade',[
    'businessServices/converters/textConverter',
    'businessServices/url/urlBuilder',
    'common/collections/enumerationKeyValueConverter',
    'constants/integrationsConstants',
    'i18next',
    'presentation/settings/integrations/presentationObjects/integrationPresentationObject'
], function() {
    const TextConverter = require('businessServices/converters/textConverter');
    const _textConverter = new TextConverter();

    const IntegrationPresentationObjectConstructor = require('presentation/settings/integrations/presentationObjects/integrationPresentationObject');
    const UrlBuilder = require('businessServices/url/urlBuilder');

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const integrationSocket = clientWebSocket.forApplication("integrations");

    const _i18n = require('i18next');
    const _integrationsConstants = require('constants/integrationsConstants');
    const _keyValueConverter = require('common/collections/enumerationKeyValueConverter');

    let _promiseFactory = null;

    const _buildOauthUrl = (platform) => {
        let urlBuilder = new UrlBuilder(platform.oAuthUrl);
        urlBuilder.addQueryString("response_type", "code");
        urlBuilder.addQueryString("client_id", platform.clientId);
        switch (platform.platformId) {
            case _integrationsConstants.clio:
                urlBuilder.addQueryString("redirect_uri", `${window.location.origin}/system/integrations/add/Clio`);
                return urlBuilder.buildUrl();
            case _integrationsConstants.hubSpot:
                urlBuilder.addQueryString("scope", "oauth%20crm.objects.contacts.read%20crm.objects.contacts.write");
                urlBuilder.addQueryString("redirect_uri", `${window.location.origin}/system/integrations/add/HubSpot`);
                return urlBuilder.buildUrl();
            case _integrationsConstants.lawmatics:
                urlBuilder.addQueryString("redirect_uri", encodeURIComponent(`${window.location.origin}/system/integrations/add/Lawmatics`));
                return urlBuilder.buildUrl();
            case _integrationsConstants.myCase:
                urlBuilder.addQueryString("redirect_uri", `${window.location.origin}/system/integrations/add/MyCase`);
                return urlBuilder.buildUrl();
            case _integrationsConstants.jobber:
                urlBuilder.addQueryString("redirect_uri", `${window.location.origin}/system/integrations/add/Jobber`);
                return urlBuilder.buildUrl();
            case _integrationsConstants.practicePanther:
                urlBuilder.addQueryString("redirect_uri", `${window.location.origin}/system/integrations/add/PracticePanther`);
                return urlBuilder.buildUrl();
            case _integrationsConstants.smokeball:
                urlBuilder.addQueryString("redirect_uri", `${window.location.origin}/system/integrations/add/Smokeball`);
                return urlBuilder.buildUrl();
            case _integrationsConstants.zapier:
                return urlBuilder.buildUrl();
            default:
                urlBuilder.clear();
                return null;
        }        
    };

    const _getI18nContext = (platformId) => {
        const integrationsConstants = _keyValueConverter.convertToKeyValues(_integrationsConstants);
        const foundIntegration = integrationsConstants.find((item) => item.value === platformId);
        return _textConverter.camelCase(foundIntegration.key);
    };

    const _getIntegrations = () => {
        return _promiseFactory.defer((promise) => {
            integrationSocket.send("retrieve", {}, (response) => {
                const integrations = response
                    .map((integration) => {
                        const i18nContext = _getI18nContext(integration.platformId);

                        let integrationPresentationObject = new IntegrationPresentationObjectConstructor();
                        integrationPresentationObject.platformId = integration.platformId;
                        integrationPresentationObject.name = _i18n.t("integrations:integrationName", {context: i18nContext});
                        integrationPresentationObject.description = _i18n.t("integrations:integrationDescription", {context: i18nContext});
                        integrationPresentationObject.iconCss = `integrations-card__icon--${i18nContext}`;
                        integrationPresentationObject.isConnected(integration.isConnected);
                        integrationPresentationObject.oauthUrl = _buildOauthUrl(integration);

                        return integrationPresentationObject;
                    });

                promise.resolve(integrations);
            });
        });
    };

    const _removeIntegration = (platformId) => {
        return _promiseFactory.defer((promise) => {
            integrationSocket.send("disconnect", { platformId: platformId }, (response) => {
                promise.resolve();
            });
        });
    };

    const _addClioGrowInboxLeadToken = (token) => {
        return _promiseFactory.defer((promise) => {
            const parameters = {
                platform: _integrationsConstants.clioGrow,
                authorizationCode: token
            };

            integrationSocket.send("connect", parameters, (response) => {
                promise.resolve();
            });
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function() {
        const self = this;

        self.init = _init;
        self.getIntegrations = _getIntegrations;
        self.removeIntegration = _removeIntegration;
        self.addClioGrowInboxLeadToken = _addClioGrowInboxLeadToken;
    };
});

